import axios from "axios"


export default {
  state: {
    loadAllData: {
      getSiteMenu: false,
      getSiteSettings: false,
      getNewsCategories: false,
      getNews: false,
      getSitePages: false,
      getCategoriesWShop: false,
      getAllShopsD: false
    },
    isDebug:false,
    isMobile: false,
    isViewFind: false,
    menuShow: false,
    showDialogMap: false,
    showDialogGal: false,
    drawerW: 0,
    darkTheme: true,
    titleInner: false,
    loadPathData: null,
    loadMenuData: null,
    dataAdmin: null,
    insidePage: null,
    selectTab: 0,
  },
  mutations: {
    setInsidePage(state, payload) {
      state.insidePage = payload;
    },
    setSelectTab(state, payload) {
      state.selectTab = payload;
    },
    setLoadAllData(state, payload) {
      state.loadAllData = payload;
    },
    setIsMobile(state, payload) {
      state.isMobile = payload;
    },
    setIsViewFind(state, payload) {
      state.isViewFind = payload;
    },
    setDrawer(state, payload) {
      state.menuShow = payload;
    },
    setTheme(state, payload) {
      state.darkTheme = payload;
    },
    setTitleInner(state, payload) {
      state.titleInner = payload;
    },
    setShowDialogMap(state, payload) {
      state.showDialogMap = payload;
    },
    setShowDialogGal(state, payload) {
      state.showDialogGal = payload;
    },
    setLoadPathData(state, payload) {
      state.loadPathData = payload;
    },
    setLoadMenuData(state, payload) {
      state.loadMenuData = payload;
    },
    setDataAdmin(state, payload) {
      state.dataAdmin = payload;
    },
  },
  actions: {
    setSelectTab({
      commit
    }, payload) {
      commit('setSelectTab', payload)
    },
    setInsidePage({
      commit
    }, payload) {
      commit('setInsidePage', payload)
    },
    setLoadAllData({
      commit
    }, payload) {
      commit('setLoadAllData', payload)
    },
    setIsMobile({
      commit
    }, payload) {
      commit('setIsMobile', payload)
    },
    setIsViewFind({
      commit
    }, payload) {
      commit('setIsViewFind', payload)
    },
    setDrawer({
      commit
    }, payload) {
      commit('setDrawer', payload)
    },
    setTheme({
      commit
    }, payload) {
      commit('setTheme', payload);
    },
    setTitleInner({
      commit
    }, payload) {

      commit('setTitleInner', payload);
    },
    setShowDialogMap({
      commit
    }, payload) {

      commit('setShowDialogMap', payload);
    },
    setShowDialogGal({
      commit
    }, payload) {

      commit('setShowDialogGal', payload);
    },
    setLoadPathData({
      commit
    }, payload) {

      commit('setLoadPathData', payload);

    },
    setLoadMenuData({
      commit
    }, payload) {

      commit('setLoadMenuData', payload);

    },
    setDataAdmin({
      commit
    }, payload) {
      commit('setDataAdmin', payload);
    },
  },
  getters: {

    getSelectTab(state) {
      return state.selectTab
    },
    getInsidePage(state) {
      return state.insidePage;
    },
    getLoadAllData(state) {
      //  if(DEBUG) console.log('valLoadData :>> ', Object.values(state.loadAllData));
      return state.loadAllData;
    },
    getIsMobile(state) {
      return state.isMobile;
    },
    getIsViewFind(state) {
      return state.isViewFind;
    },
    getDrawer(state) {
      return state.menuShow;
    },
    getTheme(state) {
      return state.darkTheme;
    },
    getTitleInner(state) {
      return state.titleInner;
    },
    getShowDialogMap(state) {
      return state.showDialogMap;
    },
    getShowDialogGal(state) {
      return state.showDialogGal;
    },
    getLoadMenuData(state) {
      return state.loadMenuData;
    },
    getLoadPathData(state) {
      if(DEBUG) console.log('getter getLoadMenuData :>> ');
      return state.loadPathData;
    },
    loadPathData(state) {
      let loadPD = null;
      axios({
          method: "get",
          url: "http://api.trcgagarinsky.ru/terminal__tmp/index.php/js/get_site_menu/"

        })
        .catch(function (error) {
          // handle error
          if(DEBUG) console.log("ERROR: ", error);
        })
        .then(function (response) {
          // handle success
          if(DEBUG) console.log(" response dataMenu =", response.data.menu);
          let readMnu = response.data.menu;
          /*           vApp.menu =  readMnu
                    vApp.menuh= readMnu.slice(1); */

          loadPD = {
            mnuCafePath: response.data.menu.find(jf => jf.id === '3').url,
            mnuShopsPath: response.data.menu.find(jf => jf.id === '1').url,
            mnuEntertatmentPath: response.data.menu.find(jf => jf.id === '5').url,
            mnuServicePath: response.data.menu.find(jf => jf.id === '6').url,
            mnuNewsPath: response.data.menu.find(jf => jf.id === '7').url,
            mnuAboutPath: response.data.menu.find(jf => jf.id === '8').url,
            mnuGalleryPath: response.data.menu.find(jf => jf.id === '9').url,
            mnuArendaPath: response.data.menu.find(jf => jf.id === '10').url,
            mnuContactsPath: response.data.menu.find(jf => jf.id === '11').url,

          }


          //  dispatch('setLoadPathData', loadPD)
          state.loadPathData = loadPD
          state.loadMenuData = readMnu

          //  commit('setLoadPathData', loadPD);

          const lAllData = state.loadAllData;
          lAllData.getSiteMenu = true;
          //  dispatch('setLoadAllData', lAllData)
          state.loadAllData = lAllData
          //  commit('setLoadAllData',  lAllData);
          if(DEBUG) console.log('  ___________________   :> this.state :>> ', state);
          if(DEBUG) console.log('  ___________########________   :> this :>> ', state.loadPathData);
          return state.loadPathData;

        });


    },
    getDataAdmin(state) {
      return state.dataAdmin;
    },
  }
}
